///<reference path="../../employee/sections/employee.ImageGallery.section.ts"/>
module Meevo.Plugins.Student {
    "use strict";
    /**
    * ImageGallery Section of Employee 
    */
    export class ImageGallerySection extends Meevo.Plugins.Employee.ImageGallerySection{
        public get auditNounForSave() {
            return Model.NounEnum.StudentImageGalleries;
        }
    }
}